import { Fragment } from "react"
import {
    TextField,
    InputAdornment,
    Autocomplete,
    Button,
    CircularProgress
} from "@mui/material"
import { Message, LocationOn, Email } from "@mui/icons-material"
import useContactUs from "../../hooks/contact-us/useContactUs"
import AlertDialog from "../../components/Dialog/AlertDialog"
import { companyEmail, companyAddress } from "../../app/store/constant"
import { H2, Body2, H5 } from "../../themes/typography"
import "../../styles/components/ContactUs.css"

export default function ContactUs() {

    const {
        enquiryTypes,
        formik,
        allCities,
        loading,
        openGuestPopup,
        setOpenGuestPopup,
        findTicketFormik
    } = useContactUs();

    return (
        <Fragment>
            <div className="page-view">
                <div className="page-wrapper">

                    <section className="contact-us-section">
                        <div className="contact-us-wrapper">

                            <div className="contact-us-icon">
                                <Message color="tertiary" sx={{ fontSize: '3rem' }} />
                            </div>

                            <div className="content-container">

                                <div className="contact-us-header">
                                    <H2 fontWeight={700}>
                                        Get In Touch With Us
                                    </H2>

                                    <Body2 color="var(--secondary-color)" fontWeight={500}>
                                        Didn't receive order confirmation on mail for purchases?
                                    </Body2>

                                    <ul className="terms-list" style={{ marginTop: '0' }}>
                                        <Body2>
                                            <li>
                                                For registered users, you can find it in the "My Bookings" section in your dashboard.
                                            </li>
                                        </Body2>
                                        <Body2>
                                            <li>
                                                For guest checkout transactions, click <span onClick={() => setOpenGuestPopup(true)} style={{ textDecoration: 'underline', color: 'var(--tertiary-color)', cursor: 'pointer' }}>here</span> to get a copy of the ticket.
                                            </li>
                                        </Body2>
                                    </ul>
                                </div>

                                <div className="contact-us-body">

                                    <div className="contact-us-title">
                                        <H5>
                                            Facing any issues or have any queries? Feel free to reach out to us!
                                        </H5>
                                    </div>
                                    <div className="contact-us-form">
                                        <form id="contact-us-user-form" onSubmit={formik.handleSubmit} noValidate>

                                            <div className="choose-query-type">
                                                <Autocomplete
                                                    disablePortal
                                                    id="enquiryType"
                                                    options={enquiryTypes}
                                                    fullWidth
                                                    getOptionLabel={(option) => option.label}
                                                    value={formik.values.enquiryType || null}
                                                    onChange={(event, newValue) => {
                                                        formik.setFieldValue('enquiryType', newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Choose Query Type"
                                                            required
                                                            error={formik.touched.enquiryType && Boolean(formik.errors.enquiryType)}
                                                            helperText={formik.touched.enquiryType && formik.errors.enquiryType}
                                                        />
                                                    )}
                                                />
                                            </div>

                                            <div className="choose-query-type">
                                                <TextField
                                                    id="name"
                                                    required
                                                    fullWidth
                                                    label="Name"
                                                    value={formik.values.name}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.name && Boolean(formik.errors.name)}
                                                    helperText={formik.touched.name && formik.errors.name}
                                                />
                                            </div>

                                            {formik.values.enquiryType?.value === 'business_query' && (
                                                <div className="choose-query-type-two-input">
                                                    <TextField
                                                        id="companyName"
                                                        required
                                                        fullWidth
                                                        label="Company Name"
                                                        value={formik.values.companyName}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.companyName && Boolean(formik.errors.companyName)}
                                                        helperText={formik.touched.companyName && formik.errors.companyName}
                                                    />

                                                    <Autocomplete
                                                        disablePortal
                                                        id="location"
                                                        options={allCities}
                                                        fullWidth
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(event, newValue) => {
                                                            formik.setFieldValue('location', newValue);
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                required
                                                                label="Location"
                                                                error={formik.touched.location && Boolean(formik.errors.location)}
                                                                helperText={formik.touched.location && formik.errors.location}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            )}

                                            <div className="choose-query-type-two-input">
                                                <TextField
                                                    id="contactEmail"
                                                    required
                                                    fullWidth
                                                    label="Contact Email"
                                                    value={formik.values.contactEmail}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.contactEmail && Boolean(formik.errors.contactEmail)}
                                                    helperText={formik.touched.contactEmail && formik.errors.contactEmail}
                                                />

                                                <TextField
                                                    id="contactNumber"
                                                    fullWidth
                                                    label="Contact Number"
                                                    required
                                                    value={formik.values.contactNumber}
                                                    onChange={(e) => {
                                                        const numericValue = e.target.value.replace(/\D/g, '');
                                                        formik.setFieldValue(`contactNumber`, numericValue);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.contactNumber && Boolean(formik.errors.contactNumber)}
                                                    helperText={formik.touched.contactNumber && formik.errors.contactNumber}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment
                                                                    position="start"
                                                                >
                                                                    +91
                                                                </InputAdornment>
                                                            ),
                                                            inputProps: {
                                                                maxLength: 10,
                                                                inputMode: 'numeric',
                                                                pattern: '[0-9]*'
                                                            }
                                                        },
                                                    }}
                                                />
                                            </div>


                                            {formik.values.enquiryType?.value === 'purchase_order_query' && (
                                                <div className="choose-query-type-two-input">
                                                    <TextField
                                                        id="orderId"
                                                        required
                                                        fullWidth
                                                        label="Order ID (If available)"
                                                        value={formik.values.orderId}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.orderId && Boolean(formik.errors.orderId)}
                                                        helperText={formik.touched.orderId && formik.errors.orderId}
                                                    />

                                                    <TextField
                                                        id="emailIdUsedAtCheckout"
                                                        fullWidth
                                                        label="Email ID (Used at checkout)"
                                                        required
                                                        value={formik.values.emailIdUsedAtCheckout}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.emailIdUsedAtCheckout && Boolean(formik.errors.emailIdUsedAtCheckout)}
                                                        helperText={formik.touched.emailIdUsedAtCheckout && formik.errors.emailIdUsedAtCheckout}
                                                    />
                                                </div>
                                            )}


                                            {formik.values.enquiryType?.value === 'report_issue' && (
                                                <div className="choose-query-type">
                                                    <TextField
                                                        id="eventUrl"
                                                        label="Event URL"
                                                        required
                                                        fullWidth
                                                        placeholder="https://www.shmooz.in/e/your-reported-event"
                                                        value={formik.values.eventUrl}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.eventUrl && Boolean(formik.errors.eventUrl)}
                                                        helperText={formik.touched.eventUrl && formik.errors.eventUrl}
                                                    />
                                                </div>
                                            )}

                                            <div className="choose-query-type">
                                                <TextField
                                                    id="message"
                                                    required
                                                    fullWidth
                                                    label="Message"
                                                    multiline
                                                    minRows={4}
                                                    value={formik.values.message}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.message && Boolean(formik.errors.message)}
                                                    helperText={formik.touched.message && formik.errors.message}
                                                />
                                            </div>

                                            <div className="contact-form-submit-button">
                                                <Button
                                                    variant="main"
                                                    type="submit"
                                                    disabled={loading}
                                                >
                                                    Submit {loading && !openGuestPopup && (
                                                        <CircularProgress
                                                            size={20}
                                                            sx={{
                                                                marginLeft: '0.75rem',
                                                                color: 'var(--primary-color)'
                                                            }}
                                                        />
                                                    )}
                                                </Button>
                                            </div>

                                        </form>
                                    </div>

                                </div>

                                <div className="contact-us-info">
                                    <Body2 className="align-center">
                                        <LocationOn color="secondary" /> {companyAddress}
                                    </Body2>
                                    <Body2 className="align-center">
                                        <Email color="secondary" /> <a href={`mailto:${companyEmail}`} style={{ textDecoration: 'underline', color: 'var(--tertiary-color)' }}>{companyEmail}</a>
                                    </Body2>
                                </div>

                            </div>
                        </div>
                    </section>

                </div>
            </div>

            <AlertDialog
                open={openGuestPopup}
                dialogId="find-ticket-dialog"
                dialogTitle="Find your ticket"
                primaryBtnName="Submit"
                onCancel={() => setOpenGuestPopup(false)}
                onConfirm={findTicketFormik.handleSubmit}
                loading={loading && openGuestPopup}
                disabled={loading}
            >
                <form id="find-ticket-form" onSubmit={findTicketFormik.handleSubmit} noValidate>
                    <div className="choose-query-type">
                        <TextField
                            required
                            fullWidth
                            id="eventName"
                            label="Event Name"
                            value={findTicketFormik.values.eventName}
                            onChange={findTicketFormik.handleChange}
                            onBlur={findTicketFormik.handleBlur}
                            error={findTicketFormik.touched.eventName && Boolean(findTicketFormik.errors.eventName)}
                            helperText={findTicketFormik.touched.eventName && findTicketFormik.errors.eventName}
                        />
                    </div>

                    <div className="choose-query-type">
                        <TextField
                            required
                            fullWidth
                            id="userName"
                            label="Name"
                            value={findTicketFormik.values.userName}
                            onChange={findTicketFormik.handleChange}
                            onBlur={findTicketFormik.handleBlur}
                            error={findTicketFormik.touched.userName && Boolean(findTicketFormik.errors.userName)}
                            helperText={findTicketFormik.touched.userName && findTicketFormik.errors.userName}
                        />
                    </div>

                    <div className="choose-query-type">
                        <TextField
                            required
                            fullWidth
                            id="email"
                            label="Email ID (Used at checkout)"
                            value={findTicketFormik.values.email}
                            onChange={findTicketFormik.handleChange}
                            onBlur={findTicketFormik.handleBlur}
                            error={findTicketFormik.touched.email && Boolean(findTicketFormik.errors.email)}
                            helperText={findTicketFormik.touched.email && findTicketFormik.errors.email}
                        />
                    </div>

                    <div className="choose-query-type">
                        <TextField
                            required
                            fullWidth
                            id="phone"
                            label="Phone Number"
                            value={findTicketFormik.values.phone}
                            onChange={(e) => {
                                const numericValue = e.target.value.replace(/\D/g, '');
                                findTicketFormik.setFieldValue(`phone`, numericValue);
                            }}
                            onBlur={findTicketFormik.handleBlur}
                            error={findTicketFormik.touched.phone && Boolean(findTicketFormik.errors.phone)}
                            helperText={findTicketFormik.touched.phone && findTicketFormik.errors.phone}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment
                                            position="start"
                                        >
                                            +91
                                        </InputAdornment>
                                    ),
                                    inputProps: {
                                        maxLength: 10,
                                        inputMode: 'numeric',
                                        pattern: '[0-9]*'
                                    }
                                },
                            }}
                        />
                    </div>

                    <div className="choose-query-type">
                        <TextField
                            id="orderId"
                            fullWidth
                            label="Order ID"
                            value={findTicketFormik.values.orderId}
                            onChange={findTicketFormik.handleChange}
                            onBlur={findTicketFormik.handleBlur}
                            error={findTicketFormik.touched.orderId && Boolean(findTicketFormik.errors.orderId)}
                            helperText={findTicketFormik.touched.orderId && findTicketFormik.errors.orderId}
                        />
                    </div>
                </form>
            </AlertDialog>
        </Fragment>
    )
}

/**
 * Fields based on query type
 * 
 * 1. For User Queries || For General Inquiry/Feedback
 *   - Name
 *   - Contact Email
 *   - Contact Number
 *   - Message
 * 
 * 2. For Business Queries
 *  - Name
 *  - Company Name
 *  - Location (City)
 *  - Contact Email
 *  - Contact Number
 *  - Message
 * 
 * 3. For Purchase/Order Queries
 *  - Name
 *  - Contact Email
 *  - Contact Number
 *  - Order ID (If available)
 *  - Email ID (Used at checkout)
 *  - Message
 * 
 * 4. For Reporting Issues
 *  - Name
 *  - Contact Email
 *  - Contact Number
 *  - Event URL
 *  - Message
 */